<template>
	<el-form>
		<el-card>
			<div slot="header">
				<span class="top_title">新增客户</span>
			</div>
			<CustomerAdd @close="close" ref="add"></CustomerAdd>
			<div class="dialog-footer">
				<el-button type="primary" throttle @click="sure">确定</el-button>
				<el-button @click="cancel">取消</el-button>
			</div>
		</el-card>
	</el-form>
</template>

<script>
	import CustomerAdd from '@/components/customer/add'
	export default {
	components: {
		CustomerAdd
	},
		data() {
			return {
			}
		},
		mounted() {
			this.$nextTick(()=>{
				this.$refs.add.init();
			})
		},
		methods: {
            sure(){
                this.$refs.add.submitFormClose('addform')
            },
            cancel(){
                this.$router.push({
					path: '/product'
				})
            },
            close(){
				if(this.$common.checkLimits('customerList')){
					this.$router.push({
						path: '/customer'
					})
				}else{
					this.$router.push({
						path: '/product'
					})
				}
 
            }
        }
	}
</script>

<style lang="scss" scoped>
.dialog-footer{
	padding: 30px 280px;
	display: flex;
	justify-content: center;
}
</style>
